import {ChangeDetectorRef, Component, OnInit, ChangeDetectionStrategy, inject, output, input, linkedSignal} from '@angular/core';
import {buildTimezoneOptions, timezoneSearch} from '@app/_helpers/timezone-options';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

@Component({
  selector: 'app-timezone-picker',
  templateUrl: './custom-timezone-picker.component.html',
  styleUrls: ['./custom-timezone-picker.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgSelectComponent, ReactiveFormsModule, FormsModule]
})

export class CustomTimezonePickerComponent implements OnInit {
  private cdr = inject(ChangeDetectorRef);

  readonly customPlaceholderText = input('Time Zone');
  readonly group = input('group');
  readonly isDisabled = input(false);
  readonly isClearable = input(true);
  readonly setDefaultValueInput = input('Asia/Kolkata (+05:30)', {alias: 'setDefaultValue'});
  readonly setDefaultValue = linkedSignal(() => this.setDefaultValueInput());
  readonly formControlValue = output<string>();

  public timezones = [];

  constructor() {}

  public searchFn = timezoneSearch;

  ngOnInit() {
    this.timezones = buildTimezoneOptions(this.setDefaultValue());
    setTimeout(() => {
      const setDefaultValue = this.setDefaultValue();
      if (!!setDefaultValue) {
        if (!this.timezones.some(t => t.nameValue === this.setDefaultValue())) {
          this.timezones = buildTimezoneOptions(setDefaultValue);
        }
        const found = this.timezones.find(t => t.nameValue === this.setDefaultValue());
        if (found) {
          this.setDefaultValue.set(found.name);
        }
        // Writes the list and the bound input after the first render.
        this.cdr.markForCheck();
      }
    }, 200);
  }

  onSelected(event) {
    this.formControlValue.emit(event);
  }
}
